<template>
  <fieldset>
    <p>Konfigurera en woocommerce integration med följande inställningar:</p>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Länk</div>
      </div>
      <input class="form-control" required readonly :value="url">
    </div>

    <div class="input-group mb-3">
      <div class="input-group-prepend">
        <div class="input-group-text">Topic</div>
      </div>
      <input class="form-control" readonly value="Order Created">
    </div>
  </fieldset>
</template>

<script setup lang="ts">
import { computed, ref, toRefs, watch } from "vue";
import { v4 as uuidv4 } from 'uuid';
const props = defineProps({
  modelValue: {
    type: Object,
    required: true
  }
});
const {
  modelValue
} = toRefs(props);
const emit = defineEmits(["update:modelValue"]);
const uuid = ref(null);
const serializedValue = computed(() => {
  return {
    uuid: uuid.value
  };
});
const url = computed(() => {
  return route('integrations.woocommerce', uuid.value);
});
function onUpdate() {
  emit("update:modelValue", serializedValue.value);
}
watch(modelValue, () => {
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    uuid.value = modelValue.value.uuid;
  }
  if (!uuid.value) {
    uuid.value = uuidv4();
  }
  if (JSON.stringify(modelValue.value) !== JSON.stringify(serializedValue.value)) {
    onUpdate();
  }
}, {
  immediate: true
});
</script>
